import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createSlots as _createSlots } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createBlock($setup["TheHeader"], {
    "notification-icon-props": {
      onClick: $setup.openNotificationDrawer,
      count:$setup.unreadCount ?? 0,
      hideNotificationIcon: $setup.hideNotificationIcon
    },
    "route-to-preferences": `${$setup.AppConfig.IDENTITY_BASE_URL}/#/preferences`,
    username: $setup.userStore.username,
    hideAppBarNavIcon: "",
    logout: $setup.userStore.logout,
    "account-id": $setup.userStore.getAccountId
  }, _createSlots({
    "apps-dropdown": _withCtx(() => [
      _createVNode(_component_v_img, {
        class: "mx-8 mr-14 cursor-pointer",
        width: "120px",
        "max-width": "140px",
        src: $setup.maropostLogo,
        alt: "Maropost logo",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.navigateToDashboard()))
      }, null, 8 /* PROPS */, ["src"])
    ]),
    timezone: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_v_tooltip, {
          text: "Da Vinci",
          location: "bottom"
        }, {
          activator: _withCtx(({ props: tooltipProps }) => [
            _createVNode(_component_v_btn, _mergeProps(tooltipProps, {
              class: "guide-cta__trigger cta-button",
              density: "compact",
              size: "medium",
              "aria-label": "What's new",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.router.push('/preview/Da-Vinci')))
            }), {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  color: "black",
                  size: "20"
                }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode("mdi-creation", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }, 16 /* FULL_PROPS */)
          ]),
          _: 1 /* STABLE */
        }),
        ($setup.showSettingsIcon)
          ? (_openBlock(), _createBlock(_component_v_tooltip, {
              key: 0,
              text: "Settings",
              location: "bottom"
            }, {
              activator: _withCtx(({ props: tooltipProps }) => [
                _createVNode(_component_v_btn, _mergeProps(tooltipProps, {
                  class: "guide-cta__trigger cta-button",
                  density: "compact",
                  size: "medium",
                  "aria-label": "Settings",
                  href: `/accounts/${$setup.userStore.getAccountId}/settings`,
                  onClick: $setup.handleSettingsClick
                }), {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      color: "black",
                      size: "20"
                    }, {
                      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                        _createTextVNode("mdi-cog", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }, 16 /* FULL_PROPS */, ["href"])
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_v_menu, {
          modelValue: $setup.isHelpMenuOpen,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.isHelpMenuOpen) = $event)),
          location: "bottom end"
        }, {
          activator: _withCtx(({ props: menuProps }) => [
            _createVNode(_component_v_tooltip, {
              text: "Help",
              location: "bottom"
            }, {
              activator: _withCtx(({ props: tooltipProps }) => [
                _createVNode(_component_v_btn, _mergeProps($setup.mergeProps(menuProps, tooltipProps), {
                  class: "guide-cta__trigger cta-button cta-button--dropdown",
                  density: "compact",
                  size: "medium",
                  "aria-label": "Help"
                }), {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      color: "black",
                      size: "20"
                    }, {
                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createTextVNode("mdi-help-circle", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_icon, {
                      color: "black",
                      size: "16",
                      class: "ml-1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($setup.isHelpMenuOpen ? 'mdi-menu-up' : 'mdi-menu-down'), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }, 16 /* FULL_PROPS */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_list, { density: "compact" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item, {
                  href: $setup.HELP_CENTER_URL,
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      size: "20",
                      color: "black"
                    }, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createTextVNode("mdi-book-open-variant", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, { class: "text-body-2 text-capitalize text-black" }, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createTextVNode("Maropost Galaxy", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["href"]),
                _createVNode(_component_v_list_item, {
                  href: $setup.RAISE_TICKET_URL,
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      size: "20",
                      color: "black"
                    }, {
                      default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                        _createTextVNode("mdi-ticket-confirmation-outline", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, { class: "text-body-2 text-black" }, {
                      default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                        _createTextVNode("Raise a Ticket", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["href"])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"])
      ])
    ]),
    "user-dropdown": _withCtx(() => [
      _createVNode(_component_v_divider, { vertical: "" }),
      _createVNode($setup["UserDropDown"])
    ]),
    _: 2 /* DYNAMIC */
  }, [
    ($setup.userStore.getAccountId)
      ? {
          name: "account-dropdown",
          fn: _withCtx(() => [
            _createVNode($setup["AccountsDropDown"])
          ]),
          key: "0"
        }
      : undefined,
    ($setup.userStore.getAccountId && !$setup.isTrialExpired)
      ? {
          name: "search-bar",
          fn: _withCtx(() => [
            _createVNode($setup["SearchBar"])
          ]),
          key: "1"
        }
      : undefined
  ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["notification-icon-props", "route-to-preferences", "username", "logout", "account-id"]))
}